import { toast } from "react-toastify";

const useClipboard = () => {

    const copyToClipboard = async (text, successMsg = "Copied!") => {
        try {
            if (!text) throw new Error();

            await navigator.clipboard.writeText(text);
            toast.success(successMsg);

        } catch (err) {
            toast.error("No content to copy!");
        }
    };

    return { copyToClipboard };
};

export default useClipboard;